var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper_item_long_pic"},[_c('img',{attrs:{"src":"https://img.winbaoxian.com/autoUpload/common/e241e154-0e4d-46af-9285-98c0f7009ee1.png","alt":"长图模板"}})])
}]

export { render, staticRenderFns }